import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=63cd6604&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jeroen/VirtualHosts/deduursportcoach.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63cd6604')) {
      api.createRecord('63cd6604', component.options)
    } else {
      api.reload('63cd6604', component.options)
    }
    module.hot.accept("./Home.vue?vue&type=template&id=63cd6604&", function () {
      api.rerender('63cd6604', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Home.vue"
export default component.exports